import { GtmMapper } from "./GtmMapper";
class GtmAnalyticsService {
    push(payload, clearPreviousEcommerceObject = false) {
        const dataLayer = window.dataLayer || [];
        if (clearPreviousEcommerceObject) {
            dataLayer.push({ ecommerce: null });
        }
        dataLayer.push(payload);
        const win = window;
        const isStage = !win._ENV?.version || /stage|snapshot/i.test(win._ENV.version);
        if (isStage) {
            console.log(`[GTM] ${payload.event}`, JSON.stringify(payload, null, 2));
        }
    }
    async trackPageLoad(eid, lang, pageUrl, pageTitle, previousUrl) {
        if (pageUrl === previousUrl) {
            return;
        }
        const event = {
            'event': 'pageLoad',
            'mandant': 'merat',
            'shoptype': 'onlineshop',
            'eid': eid,
            'lang': lang,
            'pageUrl': pageUrl,
            'pageTitle': pageTitle,
            'previousUrl': previousUrl,
        };
        this.push(event, false);
    }
    async trackAddToCart(items, currency) {
        if (!items.length)
            return;
        const gtmItems = await Promise.all(items.map(GtmMapper.fromCartItem));
        const total = gtmItems.reduce((acc, i) => acc + (i.price * i.quantity), 0);
        const event = {
            event: 'add_to_cart',
            ecommerce: {
                currency: currency,
                value: parseFloat(total.toFixed(2)),
                items: gtmItems
            }
        };
        this.push(event, true);
    }
    async trackRemoveFromCart(items, currency) {
        if (!items.length)
            return;
        const gtmItems = await Promise.all(items.map(GtmMapper.fromGeneric));
        const total = gtmItems.reduce((acc, i) => acc + (i.price * i.quantity), 0);
        const event = {
            event: 'remove_from_cart',
            ecommerce: {
                currency: currency,
                value: parseFloat(total.toFixed(2)),
                items: gtmItems
            }
        };
        this.push(event, true);
    }
    async trackAddToWishlist(items, currency) {
        if (!items.length)
            return;
        const gtmItems = await Promise.all(items.map(GtmMapper.fromWatchlistItem));
        const total = gtmItems.reduce((acc, i) => acc + (i.price * i.quantity), 0);
        const event = {
            event: 'add_to_wishlist',
            ecommerce: {
                currency: currency,
                value: parseFloat(total.toFixed(2)),
                items: gtmItems
            }
        };
        this.push(event, true);
    }
    async trackPurchase(order) {
        if (!order || !order.items)
            return;
        const gtmItems = await Promise.all(order.items.map((i) => GtmMapper.fromGeneric(i)));
        const total = gtmItems.reduce((acc, i) => acc + (i.price * i.quantity), 0);
        const event = {
            event: 'purchase',
            ecommerce: {
                transaction_id: order.orderNumber,
                currency: order.currency,
                value: total,
                items: gtmItems
            }
        };
        this.push(event, true);
    }
    async trackViewItem(item) {
        const v = item.variants[0];
        const mainCategory = item.categories.length === 0 ? null : item.categories[0];
        const numericPrice = v?.price?.unitPrice ? Number(v.price.unitPrice) : 0;
        const win = window;
        const loggedIn = win._ENV?.user?.authenticated === true;
        const price = loggedIn
            ? v?.price?.unitPrice
            : undefined;
        const unit_of_measurement = v?.price?.unitCode;
        const event = {
            event: 'view_item',
            ecommerce: {
                currency: v?.price?.currency || 'CHF',
                value: numericPrice,
                items: [{
                        item_id: item.itemNumber,
                        item_name: item.name,
                        item_category: mainCategory?.name,
                        item_category_id: mainCategory?.code,
                        price: price,
                        unit_of_measurement: unit_of_measurement,
                        quantity: 1
                    }]
            }
        };
        this.push(event, true);
    }
    trackCategoryClick(id, name) {
        const event = {
            event: 'gx.category',
            event_name: 'category_click',
            category_click: {
                id: id,
                name: name
            }
        };
        this.push(event);
    }
    trackSearch(type, query, results, destination = '') {
        const finalDestination = (destination && destination.params)
            ? { name: destination.name, destination: Object.values(destination.params)[0] }
            : destination;
        const event = {
            event: 'gx.search',
            event_name: 'site_search',
            site_search: {
                type: type,
                typed_query: query,
                results: results,
                no_result: results === 0,
                suggest_destination: finalDestination
            }
        };
        this.push(event);
    }
}
export default new GtmAnalyticsService();
